export const TextMessagingTestIds = {
  BACK: 'text-messaging.back-button',
  MESSAGE: 'text-messaging.message-input',
  SEND: 'text-messaging.send-button',
  SEARCH: 'text-messaging.search-input',
};
